import React from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";

import Link from "@airasia/phoenix-components/components/Link";
import ImageComponent from "@airasia/phoenix-components/components/Image";
import Text from "@airasia/phoenix-components/components/Text";


export default function merchant(props) {
    const cardData = props.data;
    const renderCard = (card, index) => {
        return (
            <Link 
            accessible
            color="primary"
            hoverUnderlined
            href={card.url}
            size="normal"
            stopPropagation
            target="tab"
            theme="AIRASIA_CLASSIC"
            type="normal"
            customProperties={{
                'aria-label': 'this is an a11y custom label',
                id:'merchantLogo'
              }}
              >
            <div style={{
            display: 'block',
            alignItems: 'center',
            textAlign: 'center'}} key={index}>
            <ImageComponent
                accessible
                centerFocus={false}
                enableProgressiveImageLoading={false}
                lazyLoadImage={false}
                src={card.image}
                theme="AIRASIA_CLASSIC"
                width="100%"
                height="100px"
            />
            <br/>
            <Text
                accessible
                display="inlineFlex"
                hasToggle={false}
                opacity={1}
                tag="p"
                textAlign="center"
                theme="AIRASIA_CLASSIC"
                translation={{}}
                type="sub"
                >
                {' '}{card.title}{' '}
                </Text>
                </div>
          </Link>
        );
    }
    return (
        cardData.map(renderCard)
    );
}
